import { useState } from 'react';
import { extApi } from '../api/extensibilityClient';

export function ActionsPage() {
  const [form, setForm] = useState({
    name: '', responsible_entity: '', direct_output_description: '', direct_output_unit: '',
    target_output: '', incremental: '', moderate: '', accelerated: '', transformational: '',
  });
  const [msg, setMsg] = useState<string | null>(null);

  const submit = async () => {
    const r = await extApi.createAction({
      name: form.name,
      responsible_entity: form.responsible_entity,
      direct_output_description: form.direct_output_description,
      direct_output_unit: form.direct_output_unit,
      target_output: form.target_output ? parseFloat(form.target_output) : null,
      scenario_outputs: {
        incremental: form.incremental ? parseFloat(form.incremental) : undefined,
        moderate: form.moderate ? parseFloat(form.moderate) : undefined,
        accelerated: form.accelerated ? parseFloat(form.accelerated) : undefined,
        transformational: form.transformational ? parseFloat(form.transformational) : undefined,
      },
    }) as { id: string };
    setMsg(`Created action ${r.id}`);
  };

  const f = (k: keyof typeof form, label: string) => (
    <label style={{ fontSize: '0.85rem' }}>{label}
      <input className="field" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
    </label>
  );

  return (
    <div>
      <h1 className="page-title">Government Actions</h1>
      <p className="page-subtitle">Action → Direct Output → downstream linkages. Scenario-enabled action assumptions.</p>
      <div className="card" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        {f('name', 'Action name *')}
        {f('responsible_entity', 'Responsible ministry/entity')}
        {f('direct_output_description', 'Direct measurable output')}
        {f('direct_output_unit', 'Unit')}
        {f('target_output', 'Target output')}
        {f('incremental', 'Incremental scenario output')}
        {f('moderate', 'Moderate scenario output')}
        {f('accelerated', 'Accelerated scenario output')}
        {f('transformational', 'Transformational scenario output')}
      </div>
      <button className="btn" type="button" onClick={submit}>Create action</button>
      {msg && <p style={{ color: '#16a34a', marginTop: '0.75rem' }}>{msg}</p>}
    </div>
  );
}
